export enum LanguageSdl {
  BRAZILIAN_PORTUGUESE = 'pt-BR',
  ENGLISH = 'en-US',
  SPANISH = 'es-ES'
}
